module.exports = __webpack_public_path__ + "static/media/DesktopBannerJan.d4e35d8e.jpg";